import type { EntityConfig } from '../types'

export const mmPayoutEntity: EntityConfig = {
  name: 'mm-payout',
  label: 'Payout',
  pluralLabel: 'Payouts',
  status: {
    field: 'status',
    options: [
      { value: 'completed', label: 'Completed', variant: 'success' },
      { value: 'pending', label: 'Pending', variant: 'warning' },
      { value: 'in-transit', label: 'In Transit', variant: 'default' },
      { value: 'failed', label: 'Failed', variant: 'destructive' },
      { value: 'cancelled', label: 'Cancelled', variant: 'secondary' },
    ],
    filters: [
      { value: 'all', label: 'All' },
      { value: 'completed', label: 'Completed' },
      { value: 'pending', label: 'Pending' },
      { value: 'in-transit', label: 'In Transit' },
      { value: 'failed', label: 'Failed' },
      { value: 'cancelled', label: 'Cancelled' },
    ],
    mappings: {
      all: ['completed', 'pending', 'in-transit', 'failed', 'cancelled'],
      completed: ['completed'],
      pending: ['pending'],
      'in-transit': ['in-transit'],
      failed: ['failed'],
      cancelled: ['cancelled'],
    }
  },
  queryFields: {
    merchantName: { field: 'merchantName', type: 'text' },
    method: { field: 'method', type: 'text' },
    reference: { field: 'reference', type: 'text' },
  },
  uiFilterFields: ['status', 'method'],
}
